function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "svg-2541142703-a",
  d: "M16 10.667l-8 8 1.88 1.88L16 14.44l6.12 6.107 1.88-1.88z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "rotate(90 16 16)"
}, React.createElement("path", {
  d: "M0 0h32v32H0z"
}), React.createElement("mask", {
  id: "svg-2541142703-b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#svg-2541142703-a"
})), React.createElement("g", {
  fill: "#2E7C87",
  mask: "url(#svg-2541142703-b)"
}, React.createElement("path", {
  d: "M0 0h32v32H0z"
})));

var SvgMenuNavArrow = function SvgMenuNavArrow(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default SvgMenuNavArrow;